import type { FaireProductEntity } from "../../entity_types/product";

export const p_22s54sj4tc: FaireProductEntity = {
  token: "p_22s54sj4tc",
  type: "product",
  name: "Red Bandana Fringe Cardigan",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/1075842e9151647338625b54c33d6bccbcee33c5d225287312d95a442ea3ab70.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6cb0f978bba4d71dab668d673d163d50b5e8d888278ee441d1bceaf675fe0c0.jpeg",
    "https://cdn.faire.com/fastly/3ef2c80ddb91faaf9ad5c6a8c2529de30053858e9b2d8d92275eb948827679e2.jpeg",
    "https://cdn.faire.com/fastly/d9f58fa45ebf734703e0e3093439afdde9fc09c18907a486719ba2c2411be8b9.jpeg",
    "https://cdn.faire.com/fastly/9432579d9e5f2758d98424093bc33fb7f7a0b48eafd98f632738240979d8e527.jpeg"
  ],
  priceDollars: 33.95,
  description: "Red Bandana Fringe Cardigan featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, long sleeves, and fringe trim along the hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:54.447Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
